import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { VehicleTypeService } from '../../services/vehicle-type.service';
import { SelectedModificationService } from '../../services/selected-modification.service';
@Component({
  selector: 'app-page-description',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './page-description.component.html',
  styleUrl: './page-description.component.scss'
})
export class PageDescriptionComponent {
  @Input() fatherPageDescriptionEnabled: boolean;

  constructor(public vehicleTypeService: VehicleTypeService,public selectedModificationService: SelectedModificationService) {

  }
}
